module.exports = {
	"Search the video": "ビデオを検索",
	"Explore": "探索",
	"Print": "印刷",
	"Download": "ダウンロード",
	"Share": "共有する",
	"Settings": "設定",
	"Language": "言語",
	"Interface Language": "インターフェイス言語",
	"Transcript / Captions Language": "スクリプト / キャプション言語",
	"Transcript Language": "スクリプト言語",
	"Captions Language": "キャプション言語",
	"Show Transcript": "スクリプトを表示",
	"Show Captions": "キャプションを表示",
	"Show Heatmap": "ヒートマップを表示",
	"Show Speakers in Transcript": "スクリプトにスピーカーを表示",
	"Keyword": "キーワード",
	"Keywords": "キーワード",
	"Topic": "トピック",
	"Topics": "トピック",
	"Speaker": "スピーカー",
	"Speakers": "スピーカー",
	"Transcript": "スクリプト",
	"Previous": "前へ",
	"Next": "次へ",
	"Clear": "クリア",
	"No results found": "該当する結果はありません",
	"try another search or explore": "別の検索または質問をしてください",
	"Share Search": "検索を共有",
	"Share Time": "タイムを共有",
	"There is no transcript available in the selected language.": "選択された言語にはトランスクリプトはありません。",
	"Show {{count}} more": "あと {{count}} 件表示する ",
	"Show {{count}} more_plural": "あと {{count}} 件表示する "
};


//////////////////
// WEBPACK FOOTER
// ./locale/ja.json
// module id = ./locale/ja.json
// module chunks = 0 1